import React, { Component } from "react";
import "../assets/Home.css";
import Graphics from "./dashboard";

export default class Home extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true
    };
  }

  render() {
    return (
		<div className="col-xs-12">
			<div className="route">
				<h5 className="title_page" >
					{sessionStorage.getItem('health_facilities_name')} -> Inicio
				</h5>
			</div>
			
			{this.props.graphics !== undefined ?
				this.props.graphics.length > 0 ? 
					<Graphics {...this.props} />
				:
					<div className="col-xs-12" style={{textAlign:'center',marginTop:'150px'}} >
						<img src={this.props.logo_1} className="img-home" alt=""/>
					</div>
			: <div className="col-xs-12" style={{textAlign:'center',marginTop:'150px'}} >
				<img src={this.props.logo_1} className="img-home" alt=""/>
			</div> }
				
			
		</div>
       
    );
  }
}